import type { ShippingStatus } from '../../lib/api/operatorConsole';

/** Raw filter inputs; the page debounces them before querying. */
export interface ShippingFilterValues {
  status: ShippingStatus | '';
  /** Exact delivery id — the "I have this number, show me it" lookup. */
  id: string;
  /** Exact certificate of a card: "which delivery did this card travel in?". */
  certificate_number: string;
  user_id: string;
  user_email: string;
  /** Inclusive calendar days (YYYY-MM-DD) on the created_at column. */
  created_from: string;
  created_to: string;
  tracking_number: string;
}

export const EMPTY_FILTERS: ShippingFilterValues = {
  status: '',
  id: '',
  certificate_number: '',
  user_id: '',
  user_email: '',
  tracking_number: '',
  created_from: '',
  created_to: '',
};

export const STATUS_OPTIONS: { value: ShippingStatus | ''; label: string }[] = [
  { value: '', label: 'All statuses' },
  { value: 'pending', label: 'Pending' },
  { value: 'waiting_for_payment', label: 'Waiting for payment' },
  { value: 'paid', label: 'Paid' },
  { value: 'shipped', label: 'Shipped' },
  { value: 'delivered', label: 'Delivered' },
  { value: 'canceled', label: 'Canceled' },
  { value: 'merged', label: 'Merged' },
];
